import * as types from '../mutation-types';
import { getProblemset } from '../../assets/api/problemset';

// State object
const state = () => ({
  allProblemsets: [],
});

// Getter functions
const getters = {
  getProblemsetByWeek: (state) => () => {
    const obj = {};
    state.allProblemsets.forEach((i) => {
      if (!obj[i.week]) obj[i.week] = [];
      obj[i.week].push({
        description: i.description,
        problem_id: i.problem_id,
        difficulty: i.difficulty,
        link: i.link,
        week: i.week,
        sample_code: i.sample_code,
        video: i.video,
      });
    });
    return obj;
  },
  getProblemsetInfoById: (state) => () => {
    const obj = {};
    state.allProblemsets.forEach((i) => {
      obj[i.problem_id] = {
        description: i.description,
        problem_id: i.problem_id,
        difficulty: i.difficulty,
        link: i.link,
        week: i.week,
      };
    });
    return obj;
  },
};

// Actions
const actions = {
  async getProblemset({ commit }, payload) {
    try {
      const { name, ver } = payload;
      const series = name.split('-')[0];
      const { data } = await getProblemset(series, name, ver);
      commit(types.SET_PROBLEMSET, data);
    } catch {
      //
    }
  },
};

// Mutations
const mutations = {
  [types.SET_PROBLEMSET](state, payload) {
    state.allProblemsets = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
